import { Button } from "@component/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@component/dialog";
import { AlertTriangleIcon } from "lucide-react";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    recipientEmails: string[];
    onConfirmRetake: () => void;
}

export default function RetakeInterviewConfirmDialog(props: Props) {
    return (
        <Dialog open={props.isOpen} onOpenChange={props.onClose}>
            <DialogContent className="max-w-lg">
                <DialogHeader>
                    <div className="flex items-center gap-3 mb-2">
                        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-yellow-100 dark:bg-yellow-900/30 flex items-center justify-center">
                            <AlertTriangleIcon className="w-5 h-5 text-yellow-600 dark:text-yellow-500" />
                        </div>
                        <DialogTitle className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                            Send Request Retake?
                        </DialogTitle>
                    </div>
                    <DialogDescription className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
                        <p>
                            You are about to send an interview retake request to <strong>{props.recipientEmails.length} candidate{props.recipientEmails.length !== 1 ? "s" : ""}</strong>.
                        </p>
                        <p>
                            Once sent, the candidate's current AI interview will be <strong>permanently reset</strong> and all existing responses will be removed.
                        </p>
                        <p>
                            <strong>This action cannot be undone.</strong>
                        </p>
                    </DialogDescription>
                </DialogHeader>

                <div className="mt-4 flex gap-3 justify-end">
                    <Button variant="outline" onClick={props.onClose}>
                        Cancel
                    </Button>
                    <Button
                        onClick={props.onConfirmRetake}
                        className="bg-blue-600 hover:bg-blue-700 text-white"
                    >
                        Continue
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    )
}